import React, { useState } from "react";
import "./PosCustomerFilterV2.css";
import PosCustomIcon from "../PosCustomIcon/PosCustomIcon";
import { ChevronDownIcon, ChevronUpIcon, FunnelIcon } from "@heroicons/react/24/outline";
import { Grid } from "@mui/material";

const PosCustomerFilterV2 = ({
  label = "Filter",
  border = "1px solid #D5D7DA",
  backgroundColor,
  width = "100%",
  fontSize = "1rem",
  textColor = "var(--surface-black)",
  lableFontWeight = 500,
  iconsSize,
  padding = "0px 0px",
  radius = "0px",
}) => {
  const style = {
    border: border,
    backgroundColor: backgroundColor,
    width: width,
    padding: padding,
    fontSize: fontSize,
    borderRadius: radius,
  };
  const [isOpen, setIsOpen] = useState(false);
  const handleExpandToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="filterV2-container" style={style}>
      <button
        className="filterV2ButtonWrapper"
        onClick={handleExpandToggle}
        style={{ color: textColor, fontWeight: lableFontWeight }}
      >
        <div className="posCustomFilterV2LeftIconContainer">
          <span className="posCustomFilterV2LeftIcon">
            <PosCustomIcon
              icon={<FunnelIcon />}
              height={iconsSize}
              width={iconsSize}
              color={textColor}
            />
          </span>
          {label}
        </div>
        <span className="posCustomFilterV2RightIcon">
          <PosCustomIcon
            icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
            height={iconsSize}
            width={iconsSize}
            color={textColor}
          />
        </span>
      </button>
      {isOpen && (
        <div className="filterV2-list-wrapper">
          <div className="filterV2-list-header">
            <p>Your selected filter will appear here</p>
          </div>
          <div className="filterV2-list-grid-container">
            <Grid container>
              <Grid item xs={12} md={5}>
                <div className="filterV2-list-title-left">
                  <p>Filters</p>
                </div>
                <div className="filterV2-list-left-items">
                  <p>Order Source</p>
                  <p>Payment Type</p>
                </div>
              </Grid>
              <Grid item xs={12} md={7}>
                <div className="filterV2-list-title-right">
                  <p>Order Source</p>
                </div>
                <div className="filterV2-list-Right-items">
                  <p>Zomato</p>
                  <p>Swiggy</p>
                  <p>Eat Sure</p>
                  <p>In-House</p>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      )}
    </div>
  );
};

export default PosCustomerFilterV2;
